import React from "react";
import { Link } from "react-router-dom";

import "./FooterAllPages.scss";

import logo from "../../assets/img/Logo.jpg";
import fbLogo from "../../assets/img/fb-logo.png";
import instaLogo from "../../assets/img/insta-logo.png";
import helloJoyLogo from "../../assets/img/logo-hellojoyagency-white-removebg-preview.png";

function Footer() {
    return (
        <footer className="footer">
            <div className="footer__container">
                <div className=" contain-reseaux">
                    <a href="/home">
                        <img className="contain-reseaux__logo logo-latruffe " src={logo} alt="Logo" />
                    </a>
                    <p style={{color: "#945F15", margin: "0.5rem"}}>Siret : 794 723 932 00016</p>
                    <Link to="/mentionsLegales" style={{color: "#945F15"}}>Mentions légales</Link>
                    <div>
                        <a href="https://www.facebook.com/latruffea4pattes?locale=fr_FR" target="_blank" rel="noreferrer">
                            <img className="contain-reseaux__logo" src={fbLogo} alt="Logo" />
                        </a>
                        <a href="https://www.instagram.com/latruffea4pattes/" target="_blank" rel="noreferrer">
                            <img className="contain-reseaux__logo" src={instaLogo} alt="Logo" />
                        </a>
                    </div>
                </div>
                <div className="contain-dev">
                    <div className="contain-dev__content">
                        <span className="contain-dev__text">Développé par</span>
                        <a 
                            href="https://hellojoyagency.com/" 
                            target="_blank" 
                            rel="noopener noreferrer"
                            className="contain-dev__link"
                        >
                            <img 
                                src={helloJoyLogo} 
                                alt="HelloJoy Agency" 
                                className="contain-dev__logo-img"
                            />
                            <span className="contain-dev__agency-name">
                                HelloJoy Agency
                            </span>
                        </a>
                    </div>
                </div>
            </div>
        </footer>
    );
}

export default Footer;

